export default {
    namespaced: true,
    state: {
        isTable: false
    },
    getters: {},
    mutations: {
        SET_IS_TABLE(state, value) {
            state.isTable = value
        }
    },
    actions: {
        setIsTable({ commit }, value) {
            commit('SET_IS_TABLE', value)
        }
    }
}
